import { Notify } from 'quasar'

Notify.setDefaults({
  position: 'top',
  textColor: 'white'
})

export default ({ Vue }) => {
  Notify.error = (message, position = 'top') => {
    Notify.create({
      color: 'red-5',
      message,
      position,
      icon: 'error_outline',
      actions: [{ icon: 'eva-close', handler: Function, color: 'red-3' }]
    })
  }

  Notify.success = (message, position = 'top') => {
    Notify.create({
      color: 'green-6',
      message,
      position,
      icon: 'check_circle_outline',
      actions: [{ icon: 'eva-close', handler: Function, color: 'green-3' }]
    })
  }

  Notify.warning = (message, position = 'top') => {
    Notify.create({
      color: 'orange-5',
      message,
      position,
      icon: 'warning',
      actions: [{ icon: 'eva-close', handler: Function, color: 'white' }]
    })
  }

  Notify.default = (message, position = 'top') => {
    Notify.create({
      color: 'grey-8',
      message,
      position,
      icon: 'check_circle_outline',
      actions: [{ icon: 'eva-close', handler: Function, color: 'grey-2' }]
    })
  }

  Vue.prototype.$notify = Notify
}
